<template>
  <ul class="space-y-2">
    <li v-for="refund in refunds" :key="refund.creationDate">
      {{ refundDescription(refund) }}
    </li>
  </ul>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import type { Refund } from '~/api/care-folders/types/care-folder'

import { subunitToUnits } from '../OrderHistory.utils'

import translations from './RefundList.translations'

defineProps<{
  refunds: Refund[]
}>()

const i18n = useI18n()

function refundDescription(refund: Refund) {
  const isStaffInitiated = refund.initiatorType === 'STAFF'

  const amount = subunitToUnits(refund)
  const formattedAmount = i18n.price({
    amount,
    currency: refund.monetaryAmount.currency,
  })
  const date = new Date(refund.creationDate)

  if (isStaffInitiated) {
    return i18n(translations.refundedByInitiator, {
      amount,
      formattedAmount,
      date,
      initiator: i18n(translations.backmarket),
    })
  }

  return i18n(translations.refunded, {
    amount,
    formattedAmount,
    date,
  })
}
</script>
